import React from 'react'

const Output = ({setOpenOutputPage, outputData}) => {
  // console.log(outputData, 'outputData')

  const columns = outputData && outputData?.length > 0 ? Object.keys(outputData[0]) : [];
  console.log(outputData, 'outputData')
  
  const transposedData = columns.map((column) => {
    return outputData?.map((row) => row[column]);
  });

  return (
   <div>
  <div onClick={() => setOpenOutputPage(false)} className="back-btn">
    Back
  </div>

  <div className="grouper-table">
    {outputData && outputData.length > 0 && (
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th
                style={{
                  background: "#dddddd",
                  textAlign: "center",
                }}
              >
                SN
              </th>
              <th
                style={{
                  background: "#dddddd",
                  textAlign: "center",
                }}
              >
                NAMES
              </th>

              {outputData.map((_, index) => (
                <th
                  key={index}
                  style={{
                    background: "#dddddd",
                    textAlign: "center",
                  }}
                >
                  VALUES
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {columns.map((column, colIndex) => (
              <tr key={colIndex}>
                <td
                  style={{
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {colIndex + 1}
                </td>

                <td
                  style={{
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {column?.toUpperCase()}
                </td>

                {transposedData[colIndex]?.map((value, rowIndex) => (
                  <td
                    key={rowIndex}
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {value === null || value === "" ? "-" : value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>
  )
}

export default Output

